import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { alertsApi, AlertRuleCreate, AlertRuleUpdate } from '../lib/api/alerts';

export function useAlertRules(serverId: string) {
  return useQuery({
    queryKey: ['alert-rules', serverId],
    queryFn: () => alertsApi.listRules(serverId),
    enabled: !!serverId,
  });
}

export function useCreateAlertRule(serverId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: AlertRuleCreate) => alertsApi.createRule(serverId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alert-rules', serverId] });
    },
  });
}

export function useUpdateAlertRule(serverId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ ruleId, data }: { ruleId: string; data: AlertRuleUpdate }) =>
      alertsApi.updateRule(serverId, ruleId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alert-rules', serverId] });
    },
  });
}

export function useDeleteAlertRule(serverId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ruleId: string) => alertsApi.deleteRule(serverId, ruleId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alert-rules', serverId] });
    },
  });
}

export function useActiveAlerts(serverId?: string) {
  return useQuery({
    queryKey: ['alerts-active', serverId],
    queryFn: () => alertsApi.listActiveAlerts(serverId),
    refetchInterval: 30000,
  });
}

export function useAlertHistory(serverId?: string) {
  return useQuery({
    queryKey: ['alerts-history', serverId],
    queryFn: () => alertsApi.listAlertHistory(serverId),
  });
}
